// extracted by mini-css-extract-plugin
export default {"wrapper":"load_wrapper__mHuUV","icon":"load_icon__wlVVB","clrtext":"load_clrtext__U2BET","nrtext":"load_nrtext__c89IU","text":"load_text__UHVBQ"};